import { Control } from 'react-hook-form';
import { FormattedMessage, IntlShape } from 'react-intl';
import PaperSection from '@rossum/components/paper-section/PaperSection';
import { Box, Divider, Stack, Typography } from '@rossum/ui/material';
import TextFieldControl from '../../../../../components/ReactHookForm/controls/TextFieldControl';
import ControlledToggle from '../../../../../components/ReactHookForm/Toggle';
import { queueSettingsRowSx } from '../../../queueSettingsRowSx';
import { QueueSettingsData } from './formType';

type NotificationsProps = {
  control: Control<QueueSettingsData>;
  intl: IntlShape;
};

const Notifications = ({ control, intl }: NotificationsProps) => (
  <PaperSection
    title={intl.formatMessage({ id: 'containers.settings.queues.bounce' })}
  >
    <Box sx={{ display: 'grid', maxWidth: 600 }}>
      <Typography variant="body2" color="text.secondary" sx={{ my: '20px' }}>
        <FormattedMessage id="containers.settings.queues.bounceEmailTo.sublabel" />
      </Typography>
      <Stack direction="row" sx={queueSettingsRowSx}>
        <div>
          <Stack alignItems="flex-start">
            <FormattedMessage id="containers.settings.queues.bounceEmailTo" />
          </Stack>
        </div>
        <TextFieldControl
          ControllerProps={{ control, name: 'emailTo' }}
          inputProps={{
            'data-cy': 'basic-setting-email-input',
          }}
          placeholder={intl.formatMessage({
            id: 'containers.settings.queues.emailTo.placeholder',
          })}
        />
      </Stack>
      <Divider />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          pt: '20px',
          mb: '20px',
        }}
      >
        <FormattedMessage id="containers.settings.queues.events.sublabel" />
      </Typography>
      <Stack direction="row" sx={queueSettingsRowSx}>
        <Stack alignItems="flex-start">
          <FormattedMessage id="containers.settings.queues.bounceUnprocessableAttachments" />
        </Stack>
        <Stack direction="row">
          <ControlledToggle<QueueSettingsData>
            control={control}
            name="unprocessableAttachments"
          />
        </Stack>
      </Stack>
      <Stack direction="row" sx={queueSettingsRowSx}>
        <Stack alignItems="flex-start">
          <FormattedMessage id="containers.settings.queues.bouncePostponedAnnotations" />
        </Stack>
        <Stack direction="row">
          <ControlledToggle<QueueSettingsData>
            control={control}
            name="postponedAnnotations"
          />
        </Stack>
      </Stack>
      <Stack direction="row" sx={queueSettingsRowSx}>
        <Stack alignItems="flex-start">
          <FormattedMessage id="containers.settings.queues.bounceDeletedAnnotations" />
        </Stack>
        <Stack direction="row">
          <ControlledToggle<QueueSettingsData>
            control={control}
            name="deletedAnnotations"
          />
        </Stack>
      </Stack>
    </Box>
  </PaperSection>
);

export default Notifications;
